import initScrollReveal from "./scripts/scrollReveal";
import initTiltEffect from "./scripts/tiltAnimation";
import initNavbar from "./scripts/navbar";
import initTheme from "./scripts/theme";
import initBugSquasher from "./scripts/bugSquasher";
import { targetElements, defaultProps } from "./data/scrollRevealConfig";

initTheme();
initNavbar();
initBugSquasher();
initScrollReveal(targetElements, defaultProps);
initTiltEffect();
